<template>
  <QDialog v-model="showDialog" no-esc-dismiss persistent>
    <QCard style="padding: 25px 0; width: 700px; max-width: 80vw">
      <div class="row justify-center items-center q-pa-md" style="width: 100%">
        <div class="col-12" style="text-align: center">
          <img src="/assets/images/alert.png" class="header-logo" />
        </div>
        <div class="col-12" style="text-align: center; padding-top: 10px">
          <h5>Are you sure you want to proceed without a personal guarantee?</h5>
          <p>Providing a personal guarantee enables an automatic online credit assessment for limits up to $300,000.</p>
          <p>Proceeding without a personal guarantee may impact the outcome of the credit application.</p>
          <p>
            Applications that are not approved automatically may be required to submit Financial Statements, and the application will take
            longer to assess.
          </p>
        </div>
        <div class="col-md-8 col-sm-12" style="text-align: center"></div>
      </div>
      <div class="text-center">
        <QBtn color="primary" no-caps @click="onCancel('continue')" style="margin-right: 20px"> Confirm </QBtn>
        <QBtn color="primary" outline no-caps @click="onCancel('close')"> Change </QBtn>
      </div>
    </QCard>
  </QDialog>
</template>

<script>
import { QBtn, QDialog, QCard } from 'quasar';

export default {
  name: 'FinanceDetailsDialog',
  components: { QBtn, QDialog, QCard },
  data: function () {
    return {
      showDialog: true
    };
  },
  computed: {},
  created() {},
  methods: {
    onCancel: function (value) {
      setTimeout(() => {
        this.$emit('closeFinanceDetailsDialog', value);
        this.showDialog = false;
      });
    }
  }
};
</script>
